import {
  LEAD_TEMPERATURES,
  LOST_REASONS,
  PAYMENT_METHODS,
  labelOf,
} from "../gulaConstants";

/** Dimensions of the lead split, in the order they are offered. */
export const SEGMENT_DIMS: { key: string; label: string; hint: string }[] = [
  { key: "temperature", label: "Temperatura", hint: "Cómo de caliente llegó" },
  {
    key: "timing",
    label: "Cuándo quiere instalar",
    hint: "Respuesta del formulario",
  },
  { key: "price", label: "Precio", hint: "Qué contestó sobre los 499 €" },
  { key: "source", label: "Origen", hint: "Por dónde entró" },
  { key: "zone", label: "Zona", hint: "Zona de instalación" },
  {
    key: "slot",
    label: "Franja pedida",
    hint: "Cuándo quiere que le llamemos",
  },
  {
    key: "arrival",
    label: "Hora de entrada",
    hint: "A qué hora dejó sus datos",
  },
  { key: "weekday", label: "Día de entrada", hint: "Qué día dejó sus datos" },
  { key: "form", label: "Formulario", hint: "Formulario de Meta" },
];

const SOURCES: Record<string, string> = {
  meta_form: "Formulario Meta",
  whatsapp: "WhatsApp",
  instagram: "Instagram",
  facebook: "Facebook",
  manual: "A mano",
  web: "Web",
};

const WEEKDAYS = [
  "",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
  "Domingo",
];

export const segmentLabel = (dim: string, key: string): string => {
  if (key === "Sin dato") return key;
  if (dim === "source") return SOURCES[key] ?? key;
  if (dim === "temperature") return labelOf(LEAD_TEMPERATURES, key) || key;
  if (dim === "weekday") return WEEKDAYS[Number(key)] ?? key;
  if (dim === "slot" || dim === "arrival")
    return key === "Noche"
      ? "Noche (21–9 h)"
      : `${key.split(",").join(" · ")} h`;
  return key;
};

export const lostLabel = (reason: string): string =>
  reason === "no_answer"
    ? "Nunca contestó"
    : labelOf(LOST_REASONS, reason) || reason;

export const methodLabel = (method: string): string =>
  method === "unknown"
    ? "Sin dato"
    : labelOf(PAYMENT_METHODS, method) || method;

export const sourceLabel = (source: string): string =>
  SOURCES[source] ?? source;
